import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow_down2.svg'


const _withScopeId = n => (_pushScopeId("data-v-33153feb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "vendor-assessment-review-question-detail",
  "data-cy": "heading-section"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "tw-flex tw-flex-row tw-justify-start tw-items-center tw-py-[20px]" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = {
  class: "tw-font-Poppins tw-text-[18px] tw-font-[600] tw-text-[#211F58]",
  "data-cy": "question-name"
}
const _hoisted_6 = { class: "tw-flex tw-items-center tw-gap-[15px] tw-text-[#B7B7B7] tw-text-[11px] tw-leading-[130%]" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "tw-text-[#904BD6] tw-text-[11px] tw-font-medium tw-py-[3px] tw-px-[5px] tw-rounded-[6px] tw-bg-[#FCFCFD] tw-border tw-border-solid tw-border-[#EEE4F9] tw-leading-[130%]"
}
const _hoisted_10 = { class: "float-right button-arrow dropdown-button-arrow-img" }
const _hoisted_11 = {
  key: 0,
  class: "dropdown-button-arrow-img",
  src: _imports_0
}
const _hoisted_12 = {
  key: 1,
  class: "collap-button-arrow-down-img",
  src: _imports_0
}
const _hoisted_13 = { class: "tw-grid tw-grid-cols-1 tw-gap-[10px]" }

import { computed, onMounted, Ref, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import CustomCheckbox from "../common/customCheckBox.vue";
import {
  assessmentQuestionAnswerValue,
  CHECKLIST_TYPE,
  COMPLIANCE_TYPE,
  RIGHT_SLIDE_MODAL_NAME,
} from "@/utils/constants";
import VendorAssessmentQuestionAttachments from "./vendorAssessmentQuestionAttachments.vue";
import VendorAssessmentQuestionYesNo from "./vendorAssessmentQuestionYesNo.vue";
import VendorAssessmentQuestionTextArea from "./vendorAssessmentQuestionTextArea.vue";
import store from "@/store";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentReviewQuestionDetail',
  props: {
  assessmentQuestion: {
    type: Object,
    default: () => ({}),
    required: true,
  },
  id: {
    type: String,
    default: "",
    required: false,
  },
  headingId: {
    type: String,
    default: "",
    required: false,
  },
  resetAllSelectedQuestions: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update-selected"],
  setup(__props, { emit: emits }) {

const props = __props;


const assessmentQuestionFormatted: Ref<any> = ref({});
const selectAll: Ref<boolean> = ref(false);
const showIcon: Ref<boolean> = ref(true);
const updatedItems: any[] = [];
const selectedItems: any = ref([]);
const notEvaluatedCount: Ref<number> = computed(() => {
  // Show if both complianceTypeValue|override of question does not have value.
  return props.assessmentQuestion.checklistItemChildren?.filter(
    (item: any) =>
      !item.checklistItemComplianceTypeValueOrgId &&
      !item.checklistItemComplianceOverride,
  ).length;
});

const isShowEvaluated: Ref<boolean> = computed(() => {
  // Show if one of complianceTypeValue|override all question have value.
  return props.assessmentQuestion.checklistItemChildren?.every(
    (item: any) =>
      item.checklistItemComplianceTypeValueOrgId ||
      item.checklistItemComplianceOverride,
  );
});

const collapseCategory = () => (showIcon.value = !showIcon.value);


const handleHeadingCheck = (value: boolean) => {
  if (value) {
    const unSelectedItems = assessmentQuestionFormatted.value.filter(
      (item: any) =>
        !selectedItems.value.some(
          (i: any) => i.checklistItemId === item.checklistItemId,
        ),
    );
    selectedItems.value = [...assessmentQuestionFormatted.value];
    emits("update-selected", unSelectedItems);
  } else {
    emits("update-selected", selectedItems.value);
    selectedItems.value = [];
  }
};

watch(
  () => props.resetAllSelectedQuestions,
  (value) => {
    selectedItems.value = [];
  },
);
const handleQuestionCheck = (value: any, item: any) => {
  if (value.isSelected) {
    selectedItems.value.push(item);
  } else {
    const index = selectedItems.value.findIndex(
      (i) => i.checklistItemId === item.checklistItemId,
    );
    if (index > -1) selectedItems.value.splice(index, 1);
  }
  emits("update-selected", [item]);
};

const handleUpdateAnswer = (value) => {
  const existingItem = updatedItems.find(
    (item) => item.checklistRequestedItemId === value.checklistRequestedItemId,
  );

  if (existingItem) Object.assign(existingItem, value);
  else updatedItems.push(value);

  store.commit("Vendor/SET_REQUESTED_UPDATED_ITEMS", updatedItems);
};

const checklistRequestedId = computed(() => {
  return store.state.Vendor.requestedDetailItem.checklistsRequested[0]
    .checklistRequestedId;
});

const showAdvanceModal = (item: any, parent, passkey) => {
  const emitData: IModalMessage = {
    component: RIGHT_SLIDE_MODAL_NAME.ASSESSMENT_REQUESTED_ADVANCED,
    properties: {
      checklistId: checklistRequestedId.value,
      checklistItemId: item.checklistItemId,
      questionData: {
        ...item,
        checklistItemCategoryLabel:
          parent.checklistItemHeadingLabel || parent.checklistItemName || "",
      },
      checklistType: CHECKLIST_TYPE.reviewChecklist,
      passkey,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_RIGHT_SLIDE_MODAL, emitData);
};

const formatAssessmentQuestion = () => {
  const complianceTypes = store.state.Assessment.assessmentQuestionTypes;
  const questions: any[] =
    props.assessmentQuestion?.checklistItemChildren || [];

  if (questions.length === 0) return;

  for (const item of questions) {
    const complianceType =
      complianceTypes.find(
        (type) => type.id === item?.checklistItemComplianceTypeOrgId,
      )?.complianceTypeValues || [];

    // Update Circle Percent for Evaluate | Override score.
    if (complianceType.length && item.checklistItemComplianceTypeValueOrgId) {
      const type = complianceType.find(
        (i) => i.id === item.checklistItemComplianceTypeValueOrgId,
      );

      if (type) item.itemCompleteValue = type.value * 100;

      if (
        type.label &&
        type.label.indexOf(assessmentQuestionAnswerValue.sufficient) > -1
      )
        item.itemCompleteValue = undefined;
    }

    // This block should be placed last because it affects priority.
    if (item.checklistItemComplianceOverride) {
      item.itemCompleteValue = item.checklistItemComplianceOverride * 100;
    }
  }

  assessmentQuestionFormatted.value = questions;
};

const initial = () => {
  formatAssessmentQuestion();
};

onMounted(() => initial());

watch(
  () => props.assessmentQuestion.checklistItemChildren,
  formatAssessmentQuestion,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.assessmentQuestion.checklistItemIsHeading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: __props.headingId,
          class: "tw-cursor-pointer tw-select-none tw-pr-[25px] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch",
          onClick: collapseCategory
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(CustomCheckbox, {
              "is-checked": 
            assessmentQuestionFormatted.value.length === selectedItems.value.length
          ,
              class: "tw-h-[20px] tw-ml-[25px] !tw-mb-0",
              size: "20px",
              "padding-left-checkbox": "35px",
              "onUpdate:isChecked": handleHeadingCheck
            }, null, 8, ["is-checked"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(__props.assessmentQuestion.checklistItemHeadingLabel ||
              __props.assessmentQuestion.checklistItemName ||
              ""), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (!assessmentQuestionFormatted.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-component-assessments-no-question-1")), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(`${assessmentQuestionFormatted.value.length} `), 1),
                  _createElementVNode("span", null, _toDisplayString(assessmentQuestionFormatted.value.length > 1
              ? _unref(getComponentUiText)(
                  "app-component-assessments-multiple-question-counter-1",
                )
              : _unref(getComponentUiText)(
                  "app-component-assessments-single-question-counter-1",
                )), 1),
                  _createElementVNode("span", null, _toDisplayString(!isShowEvaluated.value
              ? `, ${notEvaluatedCount.value} ${_unref(getComponentUiText)(
                  "app-component-assessments-review-counter-1",
                )}`
              : ""), 1)
                ])),
            (isShowEvaluated.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(getComponentUiText)("app-component-assessments-results-subtitle-1")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_10, [
              (showIcon.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : (_openBlock(), _createElementBlock("img", _hoisted_12))
            ])
          ])
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assessmentQuestionFormatted.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.checklistItemDateUpdated
        }, [
          (item.checklistItemComplianceTypeId === _unref(COMPLIANCE_TYPE).ATTACH)
            ? (_openBlock(), _createBlock(VendorAssessmentQuestionAttachments, {
                key: 0,
                "is-show-required-tag": false,
                "checklist-item": item,
                "checklist-id": checklistRequestedId.value,
                "is-evaluate": true,
                "is-selected-all": 
            selectedItems.value.filter(
              (i) => i.checklistItemId === item.checklistItemId,
            ).length > 0
          ,
                "onUpdate:selected": (value) => handleQuestionCheck(value, item),
                "onUpdate:answer": handleUpdateAnswer,
                onShowAdvanceModal: 
            (passkey) => showAdvanceModal(item, __props.assessmentQuestion, passkey)
          
              }, null, 8, ["checklist-item", "checklist-id", "is-selected-all", "onUpdate:selected", "onShowAdvanceModal"]))
            : _createCommentVNode("", true),
          (item.checklistItemComplianceTypeId === _unref(COMPLIANCE_TYPE).YES_NO)
            ? (_openBlock(), _createBlock(VendorAssessmentQuestionYesNo, {
                key: 1,
                "checklist-item": item,
                "is-show-required-tag": false,
                "is-selected-all": 
            selectedItems.value.filter(
              (i) => i.checklistItemId === item.checklistItemId,
            ).length > 0
          ,
                "is-evaluate": true,
                "onUpdate:selected": (value) => handleQuestionCheck(value, item),
                "onUpdate:answer": handleUpdateAnswer,
                onShowAdvanceModal: 
            (passkey) => showAdvanceModal(item, __props.assessmentQuestion, passkey)
          
              }, null, 8, ["checklist-item", "is-selected-all", "onUpdate:selected", "onShowAdvanceModal"]))
            : _createCommentVNode("", true),
          (item.checklistItemComplianceTypeId === _unref(COMPLIANCE_TYPE).TEXT)
            ? (_openBlock(), _createBlock(VendorAssessmentQuestionTextArea, {
                key: 2,
                "checklist-item": item,
                "is-show-required-tag": false,
                "is-evaluate": true,
                "is-selected-all": 
            selectedItems.value.filter(
              (i) => i.checklistItemId === item.checklistItemId,
            ).length > 0
          ,
                placeholder: 
            _unref(getComponentUiText)(
              'app-assessments-vendor-questions-placeholder-add-detail-1',
            )
          ,
                "onUpdate:selected": (value) => handleQuestionCheck(value, item),
                "onUpdate:answer": handleUpdateAnswer,
                onShowAdvanceModal: 
            (passkey) => showAdvanceModal(item, __props.assessmentQuestion, passkey)
          
              }, null, 8, ["checklist-item", "is-selected-all", "placeholder", "onUpdate:selected", "onShowAdvanceModal"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 512), [
      [_vShow, !showIcon.value]
    ])
  ]))
}
}

})